import { Box } from '@mui/material';
import { Fragment } from 'react';
import DNDArea from '~/components/DicomUpload/LocalUpload/DNDArea';
import FilesProcessed from '~/components/DicomUpload/LocalUpload/FilesProcessed';
import PatientDatasetsModal from '~/containers/patients-modal';
import ExportDatasetModal from '~/containers/viewer/explorer-sidebar/Export/ExportDatasetModal';
import Viewport from '~/containers/viewer/viewport';
import BackendWorkflows from '~/containers/workflows/BackendWorkflows';
import { useBackendJobOrchestrator } from '~/hooks/workflows/backend/useBackendJobOrchestrator';

/**
 * Works as a overlay layer for viewer related data
 * @returns Head-up display to show on top of Viewport
 */
function ViewportHUD() {
    return (
        <Box width="100%" height="100%" overflow="hidden">
            <DNDArea />
            <PatientDatasetsModal />
            <ExportDatasetModal />
            <BackendWorkflows />
        </Box>
    );
}

export default function Viewer() {
    useBackendJobOrchestrator();
    return (
        <Fragment>
            <Box position="relative" width="100%" height="100%">
                <Viewport />
                <ViewportHUD />
            </Box>
            <FilesProcessed />
        </Fragment>
    );
}
